import React, { useState } from "react";
import classnames from "classnames";
import { NavLink } from "react-router-dom";
import './navbar.css';

// reactstrap components
import {
  NavbarToggler,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  NavbarText,
  DropdownToggle,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container
} from "reactstrap";

class NavbarLanding extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };

  }

   componentDidMount() {
    window.addEventListener("resize", this.updateColor);
  }
  // this function opens and closes the collapse on small devices
  // it also adds navbar-transparent class to the navbar when closed
  // ad bg-white when opened
  toggle = () => {
    let newState = { isOpen: !this.state.isOpen };
    this.setState(newState);
  };

  scrollToElement(id) {
    document.getElementById(id).scrollIntoView();

    let newState = { isOpen: false };
    this.setState(newState);
  }

  render() {
    return (      
      <div>
        <Navbar className="navbarprops" expand="lg" collapseOnSelect>
          <NavbarBrand href="/" className="mr-auto nav-logo"></NavbarBrand>
          <NavbarToggler onClick={this.toggle} className="mr-2 nav-btn"/>
          <Collapse isOpen={this.state.isOpen} navbar id="navlink-container">
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink onClick={() => { this.scrollToElement('competitions') }} className="nav-link">
                  <i className="nc-icon nc-layout-11" />
                  COMPETITIONS
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink onClick={() => { this.scrollToElement('sponsors') }} className="nav-link">
                  <i className="nc-icon nc-tap-01" />
                  SPONSORS
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink onClick={() => { this.scrollToElement('contactus') }} className="nav-link">
                  <i className="nc-icon nc-satisfied" />
                  CONTACT US
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

export default NavbarLanding;
